<template>
  <v-app-bar
    color="primary-darken-1"
    :height="mobile ? '100' : undefined"
    :elevation="0"
  >
    <template
      v-if="mobile"
      #image
    >
      <v-img
        :src="logoUrl"
        class="ma-2"
      />
    </template>
    <template #prepend>
      <v-app-bar-nav-icon
        :size="smAndUp ? 'large' : 'small'"
        @click="emits('toggleNavigation')"
      />
    </template>
    <div
      class="d-flex flex-wrap ga-1 me-2"
      :style="{ maxWidth: smAndUp ? undefined : '68px' }"
    >
      <v-btn
        v-if="canAny(['manage_shifts', 'view_all_shifts'])"
        v-tooltip="t('admin_menu.schedule')"
        to="/admin/shifts/schedule"
        data-testid="nav-shift-management"
        icon="fas fa-calendar-alt"
        :size="smAndUp ? 'large' : 'x-small'"
      />
      <v-btn
        v-if="can('manage_users')"
        v-tooltip="t('user.management')"
        to="/admin/users"
        icon="fas fa-user-friends"
        :size="smAndUp ? 'large' : 'x-small'"
      />
      <v-btn
        v-if="authUser.is_admin"
        v-tooltip="t('global.administration')"
        to="/admin"
        icon="fas fa-key"
        :size="smAndUp ? 'large' : 'x-small'"
      />
      <v-btn
        v-show="currentRoute.path == '/'"
        v-tooltip="t('global.help')"
        to="/docs/publisher"
        icon="fas fa-question"
        :size="smAndUp ? 'large' : 'x-small'"
      />
      <v-btn
        v-show="currentRoute.path !== '/'"
        v-tooltip="t('global.home')"
        to="/"
        icon="fas fa-house"
        :size="smAndUp ? 'large' : 'x-small'"
      />
    </div>
  </v-app-bar>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useDisplay } from 'vuetify';
import { useAuth } from '@/composables/useAuth';
import { usePermissions } from '@/composables/usePermissions';
import { useSettings } from '@/composables/useSettings';

const emits = defineEmits(['toggleNavigation']);

const { t } = useI18n();
const { authUser } = useAuth();
const { logoUrl } = useSettings();

const { can, canAny } = usePermissions();
const { currentRoute } = useRouter();
const { mobile, smAndUp } = useDisplay();
</script>
